var exports = {
  "q": "GifIndicator.module__indicator___ZGxiN2",
};

module.exports = exports;
